import React, { useState, useEffect } from 'react';
import './TrustpilotBar.css'
import logo from '../../../../assets/Trustpilot/logo.svg'
import arrow from '../../../../assets/Trustpilot/arrow.svg'
import hoverArrow from '../../../../assets/Trustpilot/hoverArrow.svg'
import clickArrow from '../../../../assets/Trustpilot/clickArrow.svg'
import backgroundPattern from '../../../../assets/Trustpilot/backgroundPattern.svg'

const TrustpilotBar = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHovered, setIsHovered] = useState(false);
  const [isOnClick, setIsOnClick] = useState(false);
  const [isDisplayed, setIsDisplayed] = useState(false);
  const text = windowWidth >= 1072 ? "We keep our quoting service free for you, even if it isn’t free for us to offer. If you’re enjoying this resource, we’d appreciate your review on" :
                windowWidth >= 560 ? "We keep our quoting service free for you, even if it isn’t free for us to offer.\nIf you’re enjoying this resource, we’d appreciate your review on" :
                "Love our free quoting service? Rate us on"

  useEffect(() => {
    const handleWindowResize = () => {
        setWindowWidth(window.innerWidth);
    };

    const handleScroll = () => {
      let scrollToDisplayBanner = 353;
      if (windowWidth >= 554)
        scrollToDisplayBanner = 327
      if (windowWidth >= 648)
        scrollToDisplayBanner = 264
      if (windowWidth >= 768)
        scrollToDisplayBanner = 267
      if (windowWidth >= 1120)
        scrollToDisplayBanner = 278
  
      if(window.scrollY <= scrollToDisplayBanner)
        setIsDisplayed(false);
      else
        setIsDisplayed(true);
    }

    window.addEventListener('resize', handleWindowResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('resize', handleWindowResize);
        window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsOnClick(false)
  };

  const handleTrustpilotIcClick = () => {
    setIsOnClick(!isOnClick)
  }

  const arrowImg = isOnClick ? clickArrow : isHovered ? hoverArrow : arrow;
  const trustpilot_invitation_link = sessionStorage.getItem('trustpilot_invitation_link');

  return (
    <nav class={`navbar fixed-bottom justify-content-center trustpilot-navbar ${isDisplayed && "active"}`}>
      <div class='navbar-brand infoText align-items-end text-center' href={trustpilot_invitation_link}>
        {text.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            {index !== text.split('\n').length - 1 && <br />}
          </span>
        ))}
        <a className='iconWrapper' href={trustpilot_invitation_link} target='_blank'>
          <img onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={() => handleTrustpilotIcClick()} className='logo' src={logo}></img>
          <img onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={() => handleTrustpilotIcClick()} className='arrow' src={arrowImg}></img>
        </a>
      </div>

      <img className='backgroundPattern left' src={backgroundPattern} alt='backgroundLeft'></img>
      <img className='backgroundPattern right' src={backgroundPattern} alt='backgroundRight'></img>
    </nav>
  );
};

export default TrustpilotBar;
